import moment from "moment";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearIndividualXmlNews, clearXmlNews, getIndividualXmlNews, getXmlNews, resendXmlNews, updateXmlNews } from "../../../../actions/connectivity";
import { clearAllProviders, getAllProviders } from "../../../../actions/providers";
import snackbarUtils from "../../../../utils/snackbarUtils";
import ConfirmDialog from "../../../commons/dialog/confirmDialog";
import XmlNewsDialog from "./xmlNewsDialog";
import XmlNewsSearch from "./xmlNewsSearch";
import XmlNewsTable from "./xmlNewsTable";

const XmlNewsContainer = () => {
    const dispatch = useDispatch();

    const xmlNews = useSelector((state) => state.connectivity.xmlNews);
    const individualXmlNews = useSelector((state) => state.connectivity.individualXmlNews);
    const [rowSelection, setRowSelection] = useState({});
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [openXmlDialog, setOpenXmlDialog] = useState(false);
    const [wriId, setWriId] = useState();

    const loading = xmlNews.isFetching;

    const selectedRowsLength = Object.keys(rowSelection).length;

    const handleSearch = (values) => {
        setRowSelection({});
        setWriId(values.art);

        const fechaDesde = values.fechaDesde ? moment(values.fechaDesde).startOf('day').format('YYYY-MM-DDTHH:mm:ss') : null;
        const fechaHasta = values.fechaHasta ? moment(values.fechaHasta).endOf('day').format('YYYY-MM-DDTHH:mm:ss') : null;

        dispatch(getXmlNews(
            values.art,
            values.tipoFormulario,
            fechaDesde,
            fechaHasta,
            values.prestador,
            values.dni
        ));
    };

    const handleClear = () => {
        dispatch(clearXmlNews());
        setRowSelection({});
    };

    const handleVisualizarXml = (novedadId) => {
        dispatch(getIndividualXmlNews(wriId, novedadId));
        setOpenXmlDialog(true);
    };

    const handleOpenConfirmDialog = () => {
        setOpenConfirmDialog(true);
    };

    const handleSubmitSelected = () => {
        const selectedIds = Object.keys(rowSelection)

        if (selectedIds.length === 0) return;

        dispatch(resendXmlNews(wriId, selectedIds))
            .then((res) => {
                dispatch(updateXmlNews(selectedIds));
                snackbarUtils.success(`Se han enviado ${selectedIds.length} XMLs para reprocesamiento correctamente.`);
            })
            .finally(() => {
                setRowSelection({});

            });
        setOpenConfirmDialog(false)
    };


    const handleCloseConfirmDialog = () => setOpenConfirmDialog(false);

    const handleCloseXmlDialog = () => {
        setOpenXmlDialog(false);
        dispatch(clearIndividualXmlNews());
    };

    const handleArtChange = (artValue) => {
        if (artValue) {
            dispatch(getAllProviders(artValue.id));
        } else {
            dispatch(clearAllProviders());
        }
    };

    return (
        <div style={{ width: '100%' }}>
            <XmlNewsSearch
                isSearching={xmlNews.isFetching}
                handleSearch={handleSearch}
                handleClear={handleClear}
                onArtChange={handleArtChange}
            />
            <XmlNewsTable
                handleVisualizarXml={handleVisualizarXml}
                handleOpenConfirmDialog={handleOpenConfirmDialog}
                data={xmlNews.data}
                loading={loading}
                noRefresh={false}
                rowSelection={rowSelection}
                setRowSelection={setRowSelection}
            />
            <XmlNewsDialog
                open={openXmlDialog}
                onClose={handleCloseXmlDialog}
                xmlData={individualXmlNews.data}
                loading={individualXmlNews.isFetching}
            />
            <ConfirmDialog
                open={openConfirmDialog}
                handleClose={handleCloseConfirmDialog}
                handleConfirm={handleSubmitSelected}
                title={`¿Está seguro que desea reprocesar ${selectedRowsLength} ${selectedRowsLength === 1 ? 'XML' : 'XMLs'} seleccionado${selectedRowsLength === 1 ? '' : 's'}?`}
            />
        </div>
    );
};

export default XmlNewsContainer;
